import { Injectable } from '@angular/core';
import { Resource, ResourceParams, ResourceHandler, ResourceAction, ResourceRequestMethod, IResourceMethod } from '@ngx-resource/core';
import { IMongooseResult } from './api.module';

@ResourceParams({
  pathPrefix: '/api/productcategory'
})
@Injectable()
export class ProductCategoryResource extends Resource {

  constructor(handler: ResourceHandler) {
    super(handler);
  }


  @ResourceAction({
    method: ResourceRequestMethod.Get,
  })
  query: IResourceMethod<any, IMongooseResult<any>>;
}
